/* assets/ipost-flag.js
 * Ставит cart-атрибуты disable_ipost / disable_ipost_odesa / disable_ipost_lviv
 * по актуальному содержимому корзины (флаги считает секция ipost-flag).
 */
(function () {
  var SECTION = 'ipost-flag';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // flag → имя cart-атрибута (Киев остаётся на старом disable_ipost)
  var CITIES = [
    { flag: 'kyiv',  attr: 'disable_ipost' },
    { flag: 'odesa', attr: 'disable_ipost_odesa' },
    { flag: 'lviv',  attr: 'disable_ipost_lviv' }
  ];

  var origFetch = window.fetch.bind(window);
  var running = null;   // текущий промис синхронизации
  var again = false;    // пришёл новый запрос во время синхронизации
  var timer = null;

  // актуальные флаги из секции (рендерится по текущей корзине на сервере)
  function getDesired() {
    return origFetch(ROOT + '?sections=' + SECTION + '&_=' + Date.now(), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json && json[SECTION];
        if (!html) throw new Error('section not found');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var e = doc.getElementById('ipost-flag');
        if (!e) throw new Error('flag not found');
        var m = {};
        CITIES.forEach(function (c) { m[c.attr] = e.getAttribute('data-' + c.flag) || ''; });
        return m;
      });
  }

  // что сейчас реально записано в корзине
  function getCurrent() {
    return origFetch(ROOT + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var a = (cart && cart.attributes) || {};
        var m = {};
        CITIES.forEach(function (c) { m[c.attr] = a[c.attr] || ''; });
        return m;
      });
  }

  function equal(a, b) {
    return CITIES.every(function (c) { return (a[c.attr] || '') === (b[c.attr] || ''); });
  }

  function writeAttrs(attrs) {
    return origFetch(ROOT + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  function syncOnce() {
    return Promise.all([getDesired(), getCurrent()]).then(function (res) {
      if (equal(res[0], res[1])) return;
      return writeAttrs(res[0]);
    });
  }

  function sync() {
    if (running) { again = true; return running; }
    running = syncOnce()
      .catch(function (e) { console.warn('[ipost-flag]', e); })
      .then(function () {
        running = null;
        if (again) { again = false; return sync(); }
      });
    return running;
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(sync, 300);
  }

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/i;

  // перехват fetch темы/приложений
  window.fetch = function () {
    var arg = arguments[0];
    var u = (typeof arg === 'string') ? arg : (arg && arg.url) || '';
    var p = origFetch.apply(window, arguments);
    if (CART_RE.test(u)) p.then(scheduleSync, function () {});
    return p;
  };

  // перехват XHR
  try {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (CART_RE.test(url || '')) this.addEventListener('loadend', scheduleSync);
      } catch (e) {}
      return origOpen.apply(this, arguments);
    };
  } catch (e) {}

  // при загрузке страницы
  if (document.readyState !== 'loading') sync();
  else document.addEventListener('DOMContentLoaded', sync);

  // при возврате на вкладку (корзину могли поменять в другой)
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') scheduleSync();
  });

  // перед переходом в чекаут — обязательно досинхронизировать
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var t = e.target.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    clearTimeout(timer);
    var href = (t.tagName === 'A' && t.getAttribute('href')) || (ROOT + 'checkout');
    var go = function () { window.location.href = href; };
    var fallback = setTimeout(go, 4000); // не блокируем покупателя, если что-то зависло
    sync().then(function () { clearTimeout(fallback); go(); });
  }, true);
})();
